import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=a6328eb4&lang=postcss&scoped=true"

import exportComponent from "/Users/benedge/Projects/KPMG-30-Voices-FS-2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6328eb4"]])

export default __exports__